import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1117.93694,1672.03012 L1286.67106,1629.56424 L1231.44282,696.444235 L1315.80988,675.324235 L1539.77224,1565.97835 L1877.46635,1481.04659 L1518.99106,55.9548235 L928.195765,204.585412 L957.899294,965.470118 C958.689882,985.234824 933.278118,991.672471 924.581647,973.827765 L590.727529,289.517176 L0.0451764706,438.034824 L358.407529,1863.01365 L695.988706,1778.08188 L471.913412,887.540706 L556.280471,866.307765 L949.202824,1714.496 L1117.93694,1672.03012 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMatureSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconMatureSolid, _Component);

  var _super = _createSuper(IconMatureSolid);

  function IconMatureSolid() {
    _classCallCheck(this, IconMatureSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconMatureSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMature",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMatureSolid.displayName = "IconMatureSolid";
  return IconMatureSolid;
}(Component);

IconMatureSolid.glyphName = 'mature';
IconMatureSolid.variant = 'Solid';
IconMatureSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMatureSolid;
export { IconMatureSolid };